import { makeRequest } from "./index";

export async function getSchedules(filters) {
  return await makeRequest("GET", "schadules", null, filters);
}

export async function getVacanciesInSchedulesByFilters(filters) {
  return await makeRequest(
    "GET",
    "schadules/get/vacanciesUnities",
    null,
    filters
  );
}

export async function storeSchedule(data) {
  return await makeRequest("POST", "schadules", data);
}

export async function updateSchedule(id, data) {
  return await makeRequest("PUT", `schadules/${id}`, data);
}

export async function getScheduleTypes() {
  return await makeRequest("GET", "type_schedules");
}

export async function getScheduleStatus() {
  return await makeRequest("GET", "status_schedules");
}

export async function getScheduleAvailabilities() {
  return await makeRequest("GET", "availability_schedules");
}

export async function getHolidays() {
  return await makeRequest("GET", "holidays");
}

export async function storeHoliday(data) {
  return await makeRequest("POST", "holidays", data);
}

export async function updateHoliday(id, data) {
  return await makeRequest("PUT", `holidays/${id}`, data);
}

export async function removeHoliday(id) {
  return await makeRequest("DELETE", `holidays/${id}`);
}

export async function removeSchedules(schedules) {
  return await makeRequest("PATCH", "/schadules/selectRemove", schedules);
}

export async function changeSchedulesStatus(schedules) {
  return await makeRequest("PATCH", "/schadules/changeStatus", schedules);
}

export async function savePatientInSchedule(solicitationId, scheduleId) {
  return await makeRequest(
    "PATCH",
    `solicitacions/assignSchedule/${solicitationId}`,
    scheduleId
  );
}

export async function removeOrReschedulingSolicitationInSchedule(
  solicitationId,
  scheduleId
) {
  return await makeRequest(
    "PATCH",
    `solicitacions/unassignSchedule/${solicitationId}`,
    scheduleId
  );
}

export async function getExpiredVacancies() {
  return await makeRequest("GET", "schadules/get/CountExpiredVacancies");
}

export async function getBlockingReason() {
  return await makeRequest("GET", "schedule_blocking_reasons");
}
